import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ContainerScanningIcon = () => (
  <SvgIcon width="32" height="32" viewBox="0 0 32 32">
    {/* Container/box representation */}
    <path
      d="M8 10L16 6L24 10V22L16 26L8 22V10Z"
      fill="#17E88F"
      opacity="0.3"
    />
    <path
      d="M8 10L16 6L24 10L16 14L8 10Z"
      fill="#17E88F"
    />
    <path
      d="M8 10V22L16 26V14L8 10Z"
      fill="#0FB870"
    />
    <path
      d="M24 10V22L16 26V14L24 10Z"
      fill="#0D9359"
    />
    
    {/* Scan lines/check indicator */}
    <path d="M12 16L14 18L18 14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

export default ContainerScanningIcon;
